import { format } from "date-fns";
import type { WorkspacePersona } from "@/config/workspacePersona";

export const ADMIN_WORKSPACE_PERSONAS: { value: WorkspacePersona; label: string }[] = [
  { value: "leader", label: "Leader" },
  { value: "district_leader", label: "District leader" },
  { value: "teacher", label: "Teacher" },
  { value: "support_staff", label: "Support staff" },
  { value: "classified_staff", label: "Classified staff" },
];

export type AppRole = "teacher" | "principal" | "superintendent";

export const ADMIN_APP_ROLES: { value: AppRole | ""; label: string }[] = [
  { value: "", label: "No org role" },
  { value: "teacher", label: "Teacher" },
  { value: "principal", label: "Principal" },
  { value: "superintendent", label: "Superintendent" },
];

export type AccountStatus = "active" | "pending" | "suspended" | "inactive" | "removed";

export const ADMIN_ACCOUNT_STATUSES: { value: AccountStatus; label: string }[] = [
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "suspended", label: "Paused" },
  { value: "inactive", label: "Inactive" },
  { value: "removed", label: "Removed" },
];

export function isAccountPaused(status: string): boolean {
  return status === "suspended" || status === "inactive" || status === "removed";
}

export function formatAppRoles(roles: string[]): string {
  if (roles.length === 0) return "—";
  return roles
    .map((r) => ADMIN_APP_ROLES.find((o) => o.value === r)?.label ?? r)
    .join(", ");
}

export function formatLastLogin(value: string | null | undefined): string {
  // undefined means the RPC did not return the column — the database is behind
  // the frontend. That is unknown, not absent, and must not be reported as
  // "Never": an admin auditing dormant accounts would pause someone who signed
  // in yesterday. null is the real never-signed-in case.
  if (value === undefined) return "—";
  if (value === null || !value.trim()) return "Never";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  return format(date, "MMM d, yyyy · h:mm a");
}
